export interface Stock {
  id: number;
  lager: string;
  name1: string;
}
